import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import emailjs from 'emailjs-com';

const Contact = () => {
  const location = useLocation();

  const courses = [
    'Engineering Survey',
    'Non-Destructive Test (NDT)',
    'Quantity Estimation and Costing',
    'Project Drafting with AutoCAD',
    'Concept of Site Engineering',
    'Sub-Soil Exploration and Testing',
    'Quality Control Work and Material Testing',
    'Latest Technology of Geo-Tagging',
  ];

  const [formData, setFormData] = useState({
    enquiryType: 'student-enquiry',
    name: '',
    email: '',
    city: '',
    mobile: '',
    course: '',
    message: '',
    collegeName: '',
  });

  useEffect(() => {
    // Parse query parameters
    const params = new URLSearchParams(location.search);
    const enquiryType = params.get('enquiryType') || 'student-enquiry';
    const course = params.get('course') || '';

    setFormData((prevData) => ({
      ...prevData,
      enquiryType,
      course,
    }));
  }, [location]);

  const handleSubmit = (e) => {
    e.preventDefault();
  
    // Prepare the data to ensure default values for optional fields
    const templateParams = {
      enquiryType: formData.enquiryType || "N/A",
      name: formData.name || "N/A",
      email: formData.email || "N/A",
      city: formData.city || "N/A",
      mobile: formData.mobile || "N/A",
      course: formData.course || "N/A", // Default to "N/A" if not provided
      collegeName: formData.collegeName || "N/A", // Default to "N/A" if not provided
      message: formData.message || "N/A",
    };
  
    emailjs
      .send(
        "service_44lupdv", // Replace with your EmailJS service ID
        "template_btruigs", // Replace with your EmailJS template ID
        templateParams, // Pass the updated template parameters
        "49eZd3LDbcwlzrK4T" // Replace with your EmailJS user ID
      )
      .then(
        (response) => {
          alert("Your message has been sent successfully!");
        },
        (error) => {
          alert("Failed to send your message. Please try again later.");
        }
      );
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <div className="container py-5" style={{margin:"auto"}}>
      <h1 className="text-center heading">Contact Us</h1>
      <div className="row align-items-center mt-4">
         
        {/* Form Section */}
        <div className="col-md-7">
          <form className="mt-4" onSubmit={handleSubmit}>
            {/* Enquiry Type */}
            <div className="mb-3">
              <label htmlFor="enquiryType" className="form-label">
                Enquiry Type
              </label>
              <select
                className="form-select"
                id="enquiryType"
                name="enquiryType"
                value={formData.enquiryType}
                onChange={handleChange}
              >
                <option value="student-enquiry">Student Enquiry</option>
                <option value="college-enquiry">College Enquiry</option>
                <option value="student-enrollment">Student Enrollment</option>
              </select>
            </div>

            {/* Name */}
            <div className="mb-3">
              <label htmlFor="name" className="form-label">
                Your Name
              </label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            {/* Email */}
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Your Email
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            {/* College Name (only for college enquiry and student enrollment) */}
            {(formData.enquiryType === 'college-enquiry' ||
              formData.enquiryType === 'student-enrollment') && (
              <div className="mb-3">
                <label htmlFor="collegeName" className="form-label">
                  College Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="collegeName"
                  name="collegeName"
                  value={formData.collegeName}
                  onChange={handleChange}
                  required
                />
              </div>
            )}

            {/* City */}
            <div className="mb-3">
              <label htmlFor="city" className="form-label">
                City
              </label>
              <input
                type="text"
                className="form-control"
                id="city"
                name="city"
                value={formData.city}
                onChange={handleChange}
                required
              />
            </div>

            {/* Mobile Number */}
            <div className="mb-3">
              <label htmlFor="mobile" className="form-label">
                Mobile Number
              </label>
              <input
                type="tel"
                className="form-control"
                id="mobile"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                pattern="[0-9]{10}"
                required
              />
            </div>

            {/* Course Dropdown (only for student enrollment) */}
            {formData.enquiryType === 'student-enrollment' && (
              <div className="mb-3">
                <label htmlFor="course" className="form-label">
                  Course Selected
                </label>
                <select
                  className="form-select"
                  id="course"
                  name="course"
                  value={formData.course}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select a course</option>
                  {courses.map((course, index) => (
                    <option key={index} value={course}>
                      {course}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* Message */}
            <div className="mb-3">
              <label htmlFor="message" className="form-label">
                Your Enquiry / Message
              </label>
              <textarea
                className="form-control"
                id="message"
                name="message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            <button type="submit" className="btn btn-primary">
              Submit
            </button>
          </form>
        </div>

       {/* GIF Section */}
       <div className="col-md-5 text-center">
          <img
            src="/images/logo/contact-light.gif" // Replace with your actual GIF path
            alt="Contact Us"
            className="img-fluid rounded"
            style={{
              maxHeight: '500px', // Limit height for a consistent layout
              objectFit: 'cover',
              transition: 'transform 0.3s ease-in-out',
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Contact;
